/**
 * created by hgq
 * 组图发布（上传弹窗）
 */
import React, {Component} from 'react';
import {Modal,Tabs,Button} from "antd";
import ImagesLocally from "./imagesLocally/ImagesLocally"
import ImagesGallery from "./imagesGallery/ImagesGallery"

const { TabPane } = Tabs;

export default class UploadAtlas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedTab: '1',
            fileList: []
        };
    }


    render() {
        const operations = <div style={{color:'#F56C6C',fontSize:14,paddingTop:16,marginLeft:24}}>仅支持png. jpg. jpeg格式图片</div>;
        const {UploadAtlas,handleOk,handleCancel} = this.props;
         // let UploadAtlasHeight=window.innerHeight-294.71-400.29;
         let UploadAtlasWidth=window.innerWidth-1012.5-108;
        return(
            <Modal
                centered={true}
                title="上传图集"
                visible={UploadAtlas}
                onOk={()=>{handleOk(this.state.fileList)}}
                onCancel={handleCancel}
                maskClosable={false}
                 bodyStyle={{height:"auto",}}
                 width={UploadAtlasWidth}
                wrapClassName='popupWindow'
            >
                <div className="interval">
                    <Tabs  onChange={this.nativeBank}>
                        <TabPane tab="本地上传" key="1">
                            {this.state.selectedTab==='1' ? operations : ''}
                            <ImagesLocally onChange={(fileList)=>{
                                this.setState({fileList})
                            }} />
                        </TabPane>
                        <TabPane tab="图片库" key="2">
                            <ImagesGallery/>
                        </TabPane>
                    </Tabs>
                    <style>
                        {`
                         .popupWindow .interval .ant-tabs-bar{padding: 0px 24px;}
                         .popupWindow .interval .ant-tabs-tab {
                               font-size: 16px;
                               font-family: Microsoft YaHei;
                               font-weight: 400;
                               line-height: 22px;
                               color: #0050B3;
                               padding: 12px 0;
                          }
                    `}
                    </style>
                </div>

            </Modal>
        )
    }


    nativeBank=(activeKey)=>{
        this.setState({
            selectedTab: activeKey,
        })
    }
}
